import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ApiService} from './api.service';

@Injectable({
    providedIn: 'root'
})
export class AppSettingsService {

    private _crisisModeEnabled$ = new BehaviorSubject<boolean>(true);
    private loaded = false;
    private inflight: Promise<void> | null = null;

    constructor(private apiService: ApiService) {}

    get crisisModeEnabled$() {
        return this._crisisModeEnabled$.asObservable();
    }

    get crisisModeEnabled(): boolean {
        return this._crisisModeEnabled$.getValue();
    }

    async load(): Promise<void> {
        if (this.loaded) return;
        if (this.inflight) return this.inflight;

        this.inflight = (async () => {
            try {
                const resp: any = await this.apiService.doRequest('app-settings', 'GET', [], true);
                const enabled = resp?.data?.crisis_mode_enabled ?? resp?.crisis_mode_enabled;
                this._crisisModeEnabled$.next(enabled !== false);
                this.loaded = true;
            } catch {
                // On failure keep the default (true) so the link stays visible.
            } finally {
                this.inflight = null;
            }
        })();

        return this.inflight;
    }
}
